/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

var bridge = {
  call: function call(method, args, cb) {
    var ret = '';
    if (typeof args == 'function') {
      cb = args;
      args = {};
    }
    var arg = {
      data: args === undefined ? null : args
    };
    if (typeof cb == 'function') {
      var cbName = 'dscb' + window.dscb++;
      window[cbName] = cb;
      arg['_dscbstub'] = cbName;
    }
    arg = JSON.stringify(arg);
    if (window._dsbridge) {
      ret = _dsbridge.call(method, arg);
    } else if (window._dswk || navigator.userAgent.indexOf('_dsbridge') != -1) {
      ret = prompt('_dsbridge=' + method, arg);
    }
    return JSON.parse(ret || '{}').data;
  },
  register: function register(name, fun, asyn) {
    var q = asyn ? window._dsaf : window._dsf;
    if (!window._dsInit) {
      window._dsInit = true;
      setTimeout(function () {
        bridge.call('_dsb.dsinit');
      }, 0);
    }
    if (_typeof(fun) == 'object') {
      q._obs[name] = fun;
    } else {
      q[name] = fun;
    }
  },
  registerAsyn: function registerAsyn(name, fun) {
    this.register(name, fun, true);
  },
  hasNativeMethod: function hasNativeMethod(name, type) {
    return this.call('_dsb.hasNativeMethod', {
      name: name,
      type: type || 'all'
    });
  },
  disableJavascriptDialogBlock: function disableJavascriptDialogBlock(disable) {
    this.call('_dsb.disableJavascriptDialogBlock', {
      disable: disable !== false
    });
  }
};
!function () {
  if (window._dsf) return;
  var ob = {
    _dsf: {
      _obs: {}
    },
    _dsaf: {
      _obs: {}
    },
    dscb: 0,
    dsBridge: bridge,
    close: function close() {
      bridge.call('_dsb.closePage');
    },
    _handleMessageFromNative: function _handleMessageFromNative(info) {
      var arg = JSON.parse(info.data);
      var ret = {
        id: info.callbackId,
        complete: true
      };
      var f = this._dsf[info.method];
      var af = this._dsaf[info.method];
      var callSyn = function callSyn(f, ob) {
        ret.data = f.apply(ob, arg);
        bridge.call('_dsb.returnValue', ret);
      };
      var callAsyn = function callAsyn(f, ob) {
        arg.push(function (data, complete) {
          ret.data = data;
          ret.complete = complete !== false;
          bridge.call('_dsb.returnValue', ret);
        });
        f.apply(ob, arg);
      };
      if (f) {
        callSyn(f, this._dsf);
      } else if (af) {
        callAsyn(af, this._dsaf);
      } else {
        var name = info.method.split('.');
        if (name.length < 2) return;
        var method = name.pop();
        var namespace = name.join('.');
        var obs = this._dsf._obs;
        var ob = obs[namespace] || {};
        var m = ob[method];
        if (m && typeof m == 'function') {
          callSyn(m, ob);
          return;
        }
        obs = this._dsaf._obs;
        ob = obs[namespace] || {};
        m = ob[method];
        if (m && typeof m == 'function') {
          callAsyn(m, ob);
          return;
        }
      }
    }
  };
  for (var attr in ob) {
    window[attr] = ob[attr];
  }
  bridge.register('_hasJavascriptMethod', function (method) {
    var name = method.split('.');
    if (name.length < 2) {
      return !!(_dsf[name] || _dsaf[name]);
    } else {
      var method = name.pop();
      var namespace = name.join('.');
      var ob = _dsf._obs[namespace] || _dsaf._obs[namespace];
      return ob && !!ob[method];
    }
  });
}();

var name = "@gwm/bridge";
var version = "0.8.14";
var description = "长城通用桥接";
var main = "dist/index.cjs.js";
var module = "dist/index.esm.mjs";
var types = "dist/index.d.ts";
var exports = {
	".": {
		"import": "./dist/index.esm.mjs",
		require: "./dist/index.cjs.js"
	}
};
var scripts = {
	dev: "cross-env NODE_ENV=dev rollup --config rollup.watch.js -w",
	build: "cross-env NODE_ENV=prod rollup -c",
	test: "echo \"Error: no test specified\" && exit 1",
	"lint:lint-staged": "lint-staged",
	log: "conventional-changelog -p custom-config -i CHANGELOG.md -s -r -n ./changelog-option.js",
	release: "release-it",
	"release:patch": "release-it patch",
	"release:beta": "release-it patch --preRelease=beta",
	prepare: "husky install"
};
var repository = {
	type: "git",
	url: ""
};
var author = "GWM-FE";
var license = "MIT";
var devDependencies = {
	"@babel/core": "^7.19.0",
	"@babel/preset-env": "^7.19.0",
	"@commitlint/cli": "^17.8.1",
	"@commitlint/config-conventional": "^17.8.1",
	"@release-it/conventional-changelog": "^8.0.1",
	"@rollup/plugin-babel": "^6.0.4",
	"@rollup/plugin-html": "^1.0.2",
	"@rollup/plugin-json": "^6.1.0",
	"@rollup/plugin-terser": "^0.4.4",
	"@typescript-eslint/eslint-plugin": "^5.53.0",
	"@typescript-eslint/parser": "^5.53.0",
	"conventional-changelog-cli": "^4.1.0",
	"conventional-changelog-custom-config": "^0.3.1",
	"cross-env": "^7.0.3",
	"cz-conventional-changelog": "^3.3.0",
	ejs: "^3.1.9",
	eslint: "^8.34.0",
	"eslint-config-prettier": "^8.6.0",
	"eslint-plugin-prettier": "^4.2.1",
	"fast-glob": "^3.2.12",
	husky: "^8.0.3",
	"lint-staged": "^13.1.0",
	"markdown-it": "^14.0.0",
	"markdown-it-anchor": "^8.6.7",
	"markdown-it-toc-done-right": "^4.2.0",
	prettier: "^2.8.4",
	"release-it": "^17.0.1",
	rollup: "^2.79.0",
	"rollup-plugin-cleanup": "^3.2.1",
	"rollup-plugin-clear": "^2.0.7",
	"rollup-plugin-copy": "^3.5.0",
	"rollup-plugin-dts": "^4.2.2",
	"rollup-plugin-generate-html-template": "^1.7.0",
	"rollup-plugin-serve": "^2.0.2",
	"rollup-plugin-typescript2": "^0.33.0",
	tslib: "^2.5.0",
	typescript: "^4.9.5",
	vue: "^3.2.47",
	ws: "^8.14.2"
};
var files = [
	"dist"
];
var publishConfig = {
	registry: "https://gwmdc-npm.pkg.coding.net/ora-truck-project/npm-fe/",
	access: "public"
};
var dependencies = {
	"compare-func": "^2.0.0"
};
var packageJson = {
	name: name,
	version: version,
	description: description,
	main: main,
	module: module,
	types: types,
	exports: exports,
	scripts: scripts,
	repository: repository,
	author: author,
	license: license,
	devDependencies: devDependencies,
	"lint-staged": {
	"*.{js,ts}": [
		"eslint --fix",
		"prettier --write"
	],
	"package.json": [
		"prettier --write"
	],
	"*.md": [
		"prettier --write"
	]
},
	files: files,
	publishConfig: publishConfig,
	dependencies: dependencies
};

var BrandEnum;
(function (BrandEnum) {
    BrandEnum[BrandEnum["ORA"] = 3] = "ORA";
    BrandEnum[BrandEnum["PICKUP"] = 5] = "PICKUP";
    BrandEnum[BrandEnum["HAVAL"] = 1] = "HAVAL";
    BrandEnum[BrandEnum["WEY"] = 2] = "WEY";
    BrandEnum[BrandEnum["TANK"] = 7] = "TANK";
    BrandEnum[BrandEnum["SOUL"] = 9] = "SOUL";
    BrandEnum[BrandEnum["GWM"] = 10] = "GWM";
})(BrandEnum || (BrandEnum = {}));

var CONFIG_CONVERT_USER_INFO = {
    1: {
        userId: 'suserId',
    },
    2: {
        android: {
            ptToken: 'ssoToken',
        },
    },
    3: {
        ios: {
            ptToken: 'object.SSO.ptToken',
        },
        android: {
            nick: 'nickName',
            refreshToken: 'ssoToken',
            avatar: 'userPicture',
            phone: 'mobilePhone',
            ssoToken: '',
            ptToken: 'object.SSO.ptToken',
        },
    },
    7: {
        android: {
            ptToken: 'ssoToken',
        },
    },
};
var CONFIG_CONVERT_CAR_INFO = {
    1: {
        ios: {
            modelName: 'vtype',
        },
        android: {
            modelName: 'vtype',
        },
    },
    2: {
        ios: {
            modelName: 'scmsModelName',
        },
        android: {
            modelName: 'scmsModelName',
        },
    },
    3: {
        ios: {
            licenseNumber: 'carNumber',
        },
        android: {
            modelName: 'vTypeName',
        },
    },
    7: {
        ios: {
            modelName: 'brandName',
        },
        android: {
            modelName: 'brandName',
        },
    },
    10: {
        ios: {
            modelName: 'vtype',
        },
        android: {
            modelName: 'vtype',
        },
    },
};

var getType = function (data) {
    return Object.prototype.toString.call(data);
};
var isArray = function (data) {
    return getType(data) === '[object Array]';
};
var isObject = function (data) {
    return getType(data) === '[object Object]';
};

var change = function (data, rule) {
    for (var k in rule) {
        var rItem = rule[k];
        var keys = rItem.split('.');
        if (keys.length > 1) {
            var val = data[keys[0]];
            for (var i = 1; i < keys.length; i++) {
                val = (val === null || val === void 0 ? void 0 : val[keys[i]]) || '';
            }
            data[k] = val;
        }
        else if (rule[k] === '') {
            data[k] = '';
        }
        else {
            data[k] = data[rItem] || '';
        }
    }
    return data;
};
var cover = function (data, rule) {
    if (isArray(data)) {
        var res = data.map(function (item) {
            var tmp = __assign({}, item);
            return change(tmp, rule);
        });
        return res;
    }
    else {
        if (isObject(data)) {
            var res = __assign({}, data);
            return change(res, rule);
        }
        return data;
    }
};
var getConfig = function (convertConfig, self) {
    if (convertConfig[self.brand]) {
        var convertBrand = convertConfig[self.brand];
        if (convertBrand[self.platform]) {
            return convertBrand[self.platform];
        }
        else {
            if (convertBrand['ios'] || convertBrand['android']) {
                return {};
            }
            else {
                return convertBrand;
            }
        }
    }
    return {};
};
// 不同品牌车型信息字段兼容
var convertCarinfo = function (res, self) {
    var map = getConfig(CONFIG_CONVERT_CAR_INFO, self);
    return cover(res, map);
};
// 不同品牌用户信息字段兼容
var convertUserInfo = function (res, self) {
    var map = getConfig(CONFIG_CONVERT_USER_INFO, self);
    return cover(res, map);
};

var BrandAll = [
    BrandEnum.ORA,
    BrandEnum.HAVAL,
    BrandEnum.PICKUP,
    BrandEnum.SOUL,
    BrandEnum.TANK,
    BrandEnum.WEY,
    BrandEnum.GWM,
];
// 桥接方法配置
var config = {
    login: {
        name: 'NativeController.presentLoginController',
        desc: '拉起登录',
        brand: BrandAll,
    },
    popView: {
        name: 'Controller.popViewController',
        desc: '关闭当前页',
        brand: BrandAll,
    },
    popToRootView: {
        name: 'Controller.popToRootViewController',
        desc: '关闭所有webview',
        brand: BrandAll,
    },
    pushView: {
        name: 'Controller.pushViewController',
        desc: '打开H5页面',
        brand: BrandAll,
        deal: function (data) {
            if (!/^https?:/.test(data.page)) {
                data.page = "".concat(window.location.origin).concat(data.page);
            }
            return data;
        },
    },
    closeView: {
        name: 'Controller.close',
        desc: '关闭当前webview',
        brand: BrandAll,
    },
    personalCard: {
        name: 'NativeController.personalCardController',
        desc: '跳转到他人主页',
        brand: BrandAll,
        multiBrand: {
            3: 'NativeController.pushNativeController',
            10: 'NativeController.pushNativeController',
        },
        deal: function (data, bridge) {
            if (bridge.brand === 3) {
                return {
                    url: "ora://app/community/personDetail?userId=".concat(data.userId),
                };
            }
            if (bridge.brand === 10) {
                return {
                    url: "sapp://app/personal/homepage?userId=".concat(data.userId),
                };
            }
            return data;
        },
    },
    pushNative: {
        name: 'NativeController.pushNativeController',
        desc: '打开原生或者 h5 路由',
        brand: BrandAll,
    },
    showModal: {
        name: 'NativeController.showNativeAlert',
        desc: '原生弹窗',
        brand: BrandAll,
        async: true,
    },
    toast: {
        name: 'NativeController.nativeToast',
        desc: '原生toast',
        brand: BrandAll,
    },
    imagePicker: {
        name: 'NativeController.presentImagePicker',
        desc: '图片选择器',
        async: true,
        multiBrand: {
            1: {
                ios: 'NativeController.presentImagePicker',
                android: 'NativeController.getAppImgList',
            },
        },
        brand: BrandAll,
    },
    takePhoto: {
        name: 'Controller.takePhoto',
        desc: '原生拍照',
        async: true,
        brand: BrandAll,
    },
    saveImageToAlbum: {
        name: 'Controller.saveImageToPhonesAlbum',
        desc: '保存到相册',
        brand: BrandAll,
        multiBrand: {
            5: {
                ios: 'GwmController.gwmSaveImage',
                android: 'Controller.saveImageToPhonesAlbum',
            },
        },
        deal: function (data, bridge) {
            if (bridge.brand === 5 && bridge.platform === 'ios') {
                return data.url;
            }
            return {
                image: data.image,
            };
        },
    },
    locationAuthStatus: {
        name: 'Storage.locationAuthorizationStatus',
        desc: '是否有定位权限',
        async: true,
        brand: BrandAll,
    },
    mapNavigation: {
        name: 'NativeController.mapNavigation',
        desc: '拉起地图导航',
        async: true,
        brand: BrandAll,
        deal: function (data, bridge) {
            var res = {
                name: data.name,
            };
            var X_PI = (Math.PI * 3000.0) / 180.0;
            // 欧拉、聚合app lat|lng只接收高德坐标系
            var brandSet = [3, 10];
            if (data.type === 1) {
                var baToGd = function () {
                    var x = Number(data.lng - 0.0065);
                    var y = Number(data.lat - 0.006);
                    var z = Number(Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI));
                    var theta = Number(Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI));
                    var gdLng = Number(z * Math.cos(theta));
                    var gdLat = Number(z * Math.sin(theta));
                    return [gdLng, gdLat];
                };
                var _a = baToGd(), gdLng = _a[0], gdLat = _a[1];
                if (brandSet.indexOf(bridge.brand) !== -1) {
                    res.lat = gdLat + '';
                    res.lng = gdLng + '';
                }
                else {
                    res.lat = data.lat + '';
                    res.lng = data.lng + '';
                }
                res.latBaidu = data.lat + '';
                res.lngBaidu = data.lng + '';
                res.latAmap = gdLat + '';
                res.lngAmap = gdLng + '';
            }
            else {
                var gdToBa = function () {
                    var x = data.lng;
                    var y = data.lat;
                    var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * X_PI);
                    var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * X_PI);
                    var btLng = z * Math.cos(theta) + 0.0065;
                    var bdLat = z * Math.sin(theta) + 0.006;
                    return [bdLat, btLng];
                };
                var _b = gdToBa(), bdLat = _b[0], btLng = _b[1];
                if (brandSet.indexOf(bridge.brand) !== -1) {
                    res.lat = data.lat + '';
                    res.lng = data.lng + '';
                }
                else {
                    res.lat = bdLat + '';
                    res.lng = btLng + '';
                }
                res.latBaidu = bdLat + '';
                res.lngBaidu = btLng + '';
                res.latAmap = data.lat + '';
                res.lngAmap = data.lng + '';
            }
            return __assign(__assign({}, data), res);
        },
    },
    locationInfo: {
        name: 'Storage.locationInfo',
        desc: '获取当前定位',
        brand: BrandAll,
    },
    mallLocationInfo: {
        name: 'Storage.mallLocationInfo',
        desc: '商城获取当前定位',
        multiBrand: {
            1: {
                ios: 'Storage.mallLocationInfo',
                android: 'Storage.mallLocationInfoWithDialog',
            },
            2: {
                ios: 'Storage.mallLocationInfo',
                android: 'Storage.mallLocationInfoWithDialog',
            },
            7: {
                ios: 'Storage.mallLocationInfo',
                android: 'Storage.mallLocationInfoWithDialog',
            },
        },
        async: true,
        timeout: 5000,
        brand: BrandAll,
    },
    refreshNav: {
        name: 'Controller.refreshNav',
        desc: '控制原生导航栏',
        brand: BrandAll,
    },
    refreshNavHidden: {
        name: 'Controller.refreshNavHidden',
        desc: '隐藏导航栏控制',
        brand: BrandAll,
    },
    disableFdInteractivePop: {
        name: 'Controller.disableFdInteractivePop',
        desc: '是否禁止左滑',
        brand: BrandAll,
        multiBrand: {
            2: {
                ios: 'Controller.disableFdInteractivePop',
                android: 'Controller.disableGoBack',
            },
        },
        deal: function (data, bridge) {
            if (bridge.brand === 2 && bridge.platform === 'android') {
                return {
                    disable: data.enable,
                };
            }
            return data;
        },
    },
    jumpVideo: {
        name: 'NativeController.jumpVideo',
        desc: '原生视频播放',
        brand: BrandAll,
    },
    deviceInfo: {
        name: 'Storage.deviceInfo',
        desc: '获取设备信息',
        brand: BrandAll,
    },
    setDeviceOrientation: {
        name: 'Controller.setDeviceOrientation',
        desc: '设置横竖屏',
        brand: BrandAll,
    },
    appBrand: {
        name: 'Storage.appBrand',
        desc: '获取品牌ID',
        brand: BrandAll,
    },
    userInfo: {
        name: 'Storage.userInfo',
        desc: '获取用户信息',
        brand: BrandAll,
        after: convertUserInfo,
    },
    share: {
        name: 'NativeController.presentShare',
        desc: '分享',
        brand: BrandAll,
    },
    carInfo: {
        name: 'Storage.userCarInfo',
        desc: '获取当前车辆信息',
        brand: BrandAll,
        after: convertCarinfo,
    },
    carInfoAll: {
        name: 'Storage.getAllCarsInfo',
        desc: '获取所有车辆信息',
        brand: BrandAll,
        after: convertCarinfo,
    },
    appInfo: {
        name: 'Storage.getAPPInfo',
        desc: '获取APP信息',
        brand: BrandAll,
    },
    appInfoAsync: {
        name: 'Storage.appInfo',
        desc: '获取APP信息(异步)',
        async: true,
        brand: BrandAll,
    },
    getStatusBarHeight: {
        name: 'Storage.getStatusBarHeight',
        desc: '获取手机 nav 高度',
        brand: BrandAll,
        after: function (res) {
            return Number(res) || 0;
        },
    },
    previewImage: {
        name: 'NativeController.previewImage',
        desc: '图片预览',
        brand: BrandAll,
    },
    callMP: {
        name: 'Controller.callWxMiniProgram',
        desc: '拉起微信小程序',
        brand: BrandAll,
    },
    sendToCar: {
        name: 'Controller.sendLocationToCar',
        desc: '发送到车',
        brand: BrandAll,
    },
    scanQrCode: {
        name: 'NativeController.pushNativeController',
        desc: '扫码',
        brand: BrandAll,
        params: {
            1: {
                ios: 'haval://app/common/openScanQRCode',
                android: 'haval://app/recommand/scan/activity',
            },
            2: {
                ios: 'wey://app/service/scanQRCode',
                android: 'wey://app/scan/activity',
            },
            3: 'ora://app/scanQRCode',
            7: {
                ios: 'tank://app/service/scanQRCode',
                android: 'tank://app/scan/activity',
            },
            10: 'sapp://app/scanqrcode',
        },
    },
    postDetail: {
        name: 'NativeController.pushNativeController',
        desc: '文章详情',
        brand: BrandAll,
        params: {
            1: 'haval://app/community/postDetail?id=',
            2: 'wey://app/community/postDetail?id=',
            3: 'ora://app/module_find/PosterDetailActivity?postId=',
            5: 'pickup://app/module_find/PosterDetailActivity?postId=',
            7: 'tank://app/community/postDetail?id=',
        },
    },
    aloneShare: {
        name: 'NativeController.functionShare',
        desc: '各平台单独分享',
        brand: BrandAll,
    },
};

function dealAsyncParams(async, target) {
    if (typeof async === 'function') {
        return async(target);
    }
    return !!async;
}
// 判断是否兼容桥接装饰器
function hasNativeMethod(async) {
    if (async === void 0) { async = false; }
    return function (_target, _name, descriptor) {
        var original = descriptor.value;
        if (typeof original === 'function') {
            descriptor.value = function (action, data, options) {
                var self = this;
                if (!bridge.hasNativeMethod(action)) {
                    console.warn("The action '".concat(action, "' app not supperd!"), "version: ".concat(self.version));
                    return async ? Promise.reject() : undefined;
                }
                return original.apply(this, [action, data, options]);
            };
        }
        return descriptor;
    };
}
function getAction(item, self) {
    // 处理不同平台不同方法名
    if (item.multi) {
        item.name = item.multi[self.platform];
    }
    // 处理不同品牌不同方法
    if (item.multiBrand) {
        if (item.multiBrand[self.brand]) {
            var name_1 = item.multiBrand[self.brand] || '';
            item.name = typeof name_1 === 'string' ? name_1 : name_1[self.platform];
        }
    }
    // 处理回调
    if (item.dealAction) {
        item.name = item.dealAction(item, self);
    }
    return item;
}
function dealAction(_target, _name, descriptor) {
    var original = descriptor.value;
    if (typeof original === 'function') {
        descriptor.value = function (item, data) {
            var async = dealAsyncParams(item.async, _target);
            var failRes = function (msg) { return (async ? Promise.reject(msg) : undefined); };
            var self = this;
            item = getAction(item, self);
            if (!bridge.hasNativeMethod(item.name)) {
                var msg = "The action '".concat(item.name, "' app not supperd!");
                console.warn(msg, "version: ".concat(self.version));
                return failRes(msg);
            }
            // 参数预处理
            if (item.deal) {
                data = item.deal(data, this);
            }
            return original.apply(this, [item, data]);
        };
    }
    return descriptor;
}
// 单独实现桥接方法
var otherMethod = ['locationInfo', 'scanQrCode', 'postDetail'];
var Bridge = /** @class */ (function () {
    function Bridge(_option) {
        this.version = packageJson.version;
        this.ua = window.navigator.userAgent;
        this.config = config;
        this.isApp = !!bridge.hasNativeMethod(this.config.appBrand.name);
        this.brand = Number(bridge.call(this.config.appBrand.name)) || 1;
        this.platform = !!this.ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ? 'ios' : 'android';
        this.dsbridge = bridge;
        // 注册函数回调Map，防止多次调用覆盖
        this.registerCbMap = new Map();
        if (_option.config) {
            this.config = __assign(__assign({}, this.config), _option.config);
        }
        this.init();
    }
    Bridge.prototype.call = function (action, data) {
        return bridge.call(action, data || undefined);
    };
    Bridge.prototype.callAsync = function (action, data, options) {
        return new Promise(function (resolve, reject) {
            var actTimer = 0;
            if (options === null || options === void 0 ? void 0 : options.timeout) {
                actTimer = window.setTimeout(function () {
                    console.error("\u6865\u63A5\u65B9\u6CD5 ".concat(action, " \u8BF7\u6C42\u8D85\u65F6"));
                    reject('桥接超时:::::' + "\u6865\u63A5\u65B9\u6CD5 ".concat(action, " \u8BF7\u6C42\u8D85\u65F6"));
                }, options.timeout);
            }
            bridge.call(action, data, function (res) {
                clearTimeout(actTimer);
                resolve(res);
            });
        });
    };
    Bridge.prototype.support = function (action) {
        if (!this.config[action]) {
            return false;
        }
        var item = getAction(this.config[action], this);
        return !!bridge.hasNativeMethod(item.name);
    };
    Bridge.prototype.nativeAction = function (item, data) {
        var _this = this;
        var async = dealAsyncParams(item.async, this);
        if (async) {
            return new Promise(function (resolve, reject) {
                var options = item.timeout ? { timeout: item.timeout } : {};
                _this.callAsync(item.name, data, options)
                    .then(function (res) {
                    resolve(res);
                })
                    .catch(function (e) {
                    reject(e);
                });
            });
        }
        else {
            var res = this.call(item.name, data);
            return item.after ? item.after(res, this) : res;
        }
    };
    Bridge.prototype.init = function () {
        var _this = this;
        var _loop_1 = function (k) {
            var item = this_1.config[k];
            if (otherMethod.indexOf(k) === -1) {
                // @ts-ignore
                this_1[k] = function (data) {
                    return _this.nativeAction(item, data);
                };
            }
        };
        var this_1 = this;
        // 初始化配置方法
        for (var k in this.config) {
            _loop_1(k);
        }
    };
    // 获取定位
    Bridge.prototype.locationInfo = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var locationTimer = setTimeout(function () {
                reject('获取定位超时');
            }, 5000);
            _this.regNativeLocationInfo(function (res) {
                clearTimeout(locationTimer);
                resolve(res);
            });
            _this.call(_this.config.locationInfo.name);
        });
    };
    // 调起客户端扫码
    Bridge.prototype.scanQrCode = function () {
        var _a, _b, _c;
        var item = this.config['scanQrCode'];
        var url = ((_a = item.params) === null || _a === void 0 ? void 0 : _a[this.brand]) || ((_b = item.params) === null || _b === void 0 ? void 0 : _b[1]);
        return !!((_c = this.pushNative) === null || _c === void 0 ? void 0 : _c.call(this, {
            url: typeof url === 'object' ? url[this.platform] : url,
        }));
    };
    // 跳转文章详情
    Bridge.prototype.postDetail = function (data) {
        var _a, _b, _c;
        var item = this.config['postDetail'];
        var url = ((_a = item.params) === null || _a === void 0 ? void 0 : _a[this.brand]) || ((_b = item.params) === null || _b === void 0 ? void 0 : _b[1]);
        return !!((_c = this.pushNative) === null || _c === void 0 ? void 0 : _c.call(this, {
            url: typeof url === 'object' ? "".concat(url[this.platform]).concat(data.id) : "".concat(url).concat(data.id),
        }));
    };
    // 获取APP版本号
    Bridge.prototype.appVersion = function () {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var appInfo, info, info, info, ver;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        appInfo = ((_a = this.appInfo) === null || _a === void 0 ? void 0 : _a.call(this)) || {};
                        if (!(this.brand === 1)) return [3 /*break*/, 3];
                        if (!(this.platform === 'android')) return [3 /*break*/, 1];
                        return [2 /*return*/, Promise.resolve((appInfo === null || appInfo === void 0 ? void 0 : appInfo.app_ver) || '')];
                    case 1: return [4 /*yield*/, ((_b = this.appInfoAsync) === null || _b === void 0 ? void 0 : _b.call(this))];
                    case 2:
                        info = _d.sent();
                        return [2 /*return*/, Promise.resolve((info === null || info === void 0 ? void 0 : info.versionName) || '')];
                    case 3:
                        if (!(this.brand === 2 || this.brand === 7)) return [3 /*break*/, 6];
                        if (!(this.platform === 'android')) return [3 /*break*/, 4];
                        info = this.call('Storage.appInfo');
                        return [2 /*return*/, Promise.resolve((info === null || info === void 0 ? void 0 : info.versionName) || '')];
                    case 4: return [4 /*yield*/, ((_c = this.appInfoAsync) === null || _c === void 0 ? void 0 : _c.call(this))];
                    case 5:
                        info = _d.sent();
                        return [2 /*return*/, Promise.resolve((info === null || info === void 0 ? void 0 : info.versionName) || '')];
                    case 6:
                        // 欧拉 皮卡 聚合app
                        if (this.brand === 3 || this.brand === 5 || this.brand === 10) {
                            if (this.platform === 'android') {
                                // 兼容聚合安卓
                                return [2 /*return*/, (appInfo === null || appInfo === void 0 ? void 0 : appInfo.app_ver) || appInfo.cVer || ''];
                            }
                            else {
                                ver = this.ua.match(/^.*?cVer=(\d+\.\d+\.\d+).*$/);
                                if (ver) {
                                    return [2 /*return*/, Promise.resolve(ver[1] || '')];
                                }
                                return [2 /*return*/, Promise.resolve('')];
                            }
                        }
                        return [2 /*return*/, Promise.resolve('')];
                }
            });
        });
    };
    Bridge.prototype.register = function (name, cb, async) {
        if (async === void 0) { async = false; }
        bridge.register(name, cb, async);
    };
    // 注册页面显示回调
    Bridge.prototype.regViewDidAppear = function (cb) {
        this.regGlobalFunc('viewDidAppear', cb);
    };
    // 登录成功回调
    Bridge.prototype.regLoginSuccess = function (cb) {
        this.regGlobalFunc('nativeLoginSuccess', cb);
    };
    // 注册定位回调
    Bridge.prototype.regNativeLocationInfo = function (cb) {
        this.regGlobalFunc('nativeLocationInfo', cb);
    };
    // 注册通用函数
    Bridge.prototype.regGlobalFunc = function (key, cb) {
        var _this = this;
        var cbList = this.registerCbMap.get(key);
        if (!cbList) {
            this.registerCbMap.set(key, [cb]);
            this.register(key, function (res) {
                var cbList = _this.registerCbMap.get(key);
                cbList.map(function (item) {
                    if (typeof item === 'function') {
                        item(res);
                    }
                });
            });
        }
        else {
            cbList.push(cb);
            this.registerCbMap.set(key, cbList);
        }
    };
    __decorate([
        hasNativeMethod()
    ], Bridge.prototype, "call", null);
    __decorate([
        hasNativeMethod(true)
    ], Bridge.prototype, "callAsync", null);
    __decorate([
        dealAction
    ], Bridge.prototype, "nativeAction", null);
    return Bridge;
}());

// 本地测试桥接模拟方法
var mockBridge = function (config$1) {
    var _a;
    // 防止重复注册
    if (((_a = window['_dsbridge']) === null || _a === void 0 ? void 0 : _a.call) || window._dswk) {
        return;
    }
    var mock = config$1.mock;
    // 部分桥接提供默认值
    var mockConfig = {
        userInfo: (mock === null || mock === void 0 ? void 0 : mock.config.userInfo) || {},
        appBrand: (mock === null || mock === void 0 ? void 0 : mock.config.appBrand) || 1,
        getStatusBarHeight: (mock === null || mock === void 0 ? void 0 : mock.config.getStatusBarHeight) || '32',
        locationAuthStatus: true,
    };
    if (mock === null || mock === void 0 ? void 0 : mock.enable) {
        window['_dsbridge'] = {
            call: function (method, arg) {
                var _a, _b;
                var name = '';
                for (var k in config) {
                    var item = config[k];
                    if (item && item.name === method) {
                        name = k;
                    }
                }
                if (!name) {
                    for (var k in config$1.config) {
                        var item = config$1.config[k];
                        if (item && item.name === method) {
                            name = k;
                        }
                    }
                }
                try {
                    var data_1 = JSON.parse(arg);
                    console.log("\u6A21\u62DF\u6865\u63A5\u65B9\u6CD5 ".concat(method, " \u8C03\u7528\u6210\u529F"));
                    var resData = mockConfig[name] || ((_a = mock === null || mock === void 0 ? void 0 : mock.config) === null || _a === void 0 ? void 0 : _a[name]) || {};
                    var res_1 = {
                        data: typeof resData === 'function' ? resData((data_1 === null || data_1 === void 0 ? void 0 : data_1.data) || {}) : resData,
                    };
                    // 定位异步调用
                    if (name === 'locationInfo') {
                        setTimeout(function () {
                            window.nativeLocationInfo(res_1.data);
                        }, 200);
                    }
                    if (data_1._dscbstub) {
                        if (Object.prototype.toString.call(res_1.data) === '[object Promise]') {
                            res_1.data
                                .then(function (result) {
                                ;
                                window[data_1._dscbstub](result);
                            })
                                .catch(function (e) {
                                ;
                                window[data_1._dscbstub]({
                                    code: -1,
                                    msg: e.message || '未知错误',
                                    data: e.stack || '未知错误',
                                });
                            });
                        }
                        else {
                            window.setTimeout(function () {
                                var _a;
                                (_a = res_1.data) === null || _a === void 0 ? true : delete _a.delay;
                                window[data_1._dscbstub](res_1.data);
                            }, ((_b = res_1.data) === null || _b === void 0 ? void 0 : _b.delay) || 0);
                        }
                    }
                    else {
                        return JSON.stringify(res_1);
                    }
                }
                catch (e) {
                    console.log(e);
                }
            },
        };
    }
};

/**
  /$$$$$$  /$$      /$$ /$$      /$$       /$$$$$$$  /$$$$$$$  /$$$$$$ /$$$$$$$   /$$$$$$  /$$$$$$$$
 /$$__  $$| $$  /$ | $$| $$$    /$$$      | $$__  $$| $$__  $$|_  $$_/| $$__  $$ /$$__  $$| $$_____/
| $$  \__/| $$ /$$$| $$| $$$$  /$$$$      | $$  \ $$| $$  \ $$  | $$  | $$  \ $$| $$  \__/| $$
| $$ /$$$$| $$/$$ $$ $$| $$ $$/$$ $$      | $$$$$$$ | $$$$$$$/  | $$  | $$  | $$| $$ /$$$$| $$$$$
| $$|_  $$| $$$$_  $$$$| $$  $$$| $$      | $$__  $$| $$__  $$  | $$  | $$  | $$| $$|_  $$| $$__/
| $$  \ $$| $$$/ \  $$$| $$\  $ | $$      | $$  \ $$| $$  \ $$  | $$  | $$  | $$| $$  \ $$| $$
|  $$$$$$/| $$/   \  $$| $$ \/  | $$      | $$$$$$$/| $$  | $$ /$$$$$$| $$$$$$$/|  $$$$$$/| $$$$$$$$
 \______/ |__/     \__/|__/     |__/      |_______/ |__/  |__/|______/|_______/  \______/ |________/
 */
function index (option) {
    mockBridge(option);
    var bridge = new Bridge(option);
    var install = function (app) {
        if (option.vue) {
            if (option.vue.version === 2) {
                app.prototype.$bridge = bridge;
            }
            else {
                app.config.globalProperties.$bridge = bridge;
            }
        }
    };
    return {
        install: install,
        bridge: bridge,
    };
}

export { index as default };
